import type { DefaultTheme } from 'styled-components';

export interface PolyLoaderConfig {
  fill: string;
  fillActive: string;
}

export function getPolyLoaderConfig(
  theme: DefaultTheme,
): Record<string, PolyLoaderConfig> {
  return {
    greyscale: {
      fill: theme.activeColorScheme.colors.backgroundDisabledStrong,
      fillActive: theme.activeColorScheme.colors.iconPrimaryBrand,
    },
    logo: {
      fill: theme.activeColorScheme.colors.background,
      fillActive: theme.activeColorScheme.colors.iconBrand,
    },
  };
}
